import React from 'react';
import { Link } from 'react-router-dom';
import InfoIcon from '@svg/info-circle.svg?react';
import './smart-protection-content.scss';

interface SmartProtectionContentProps {
    /**
     * Remaining soak days for the connection.
     * When > 0, displays an info alert with the remaining time.
     * Pass undefined or 0 (default) to hide the soak alert.
     */
    analysisDaysLeft?: number;
}

/**
 * Shared content block for the Smart Protection feature — used in both the
 * standalone Smart Protection Modal (Policy Settings) and the ECM New Policy modal.
 *
 * Renders: optional soak alert, description, and "Learn more" link.
 * Each parent wrapper is responsible for its own layout, illustration, and action buttons.
 */
export const SmartProtectionContent: React.FC<SmartProtectionContentProps> = ({ analysisDaysLeft = 0 }) => {
    const showSoakAlert = analysisDaysLeft > 0;
    const dayPlural = analysisDaysLeft === 1 ? 'day' : 'days';

    return (
        <div className="sp-content">
            {showSoakAlert && (
                <div className="sp-content-soak-alert">
                    <div className="alert-icon"><InfoIcon /></div>
                    <div className="alert-message">
                        Smart protection draft policy will be ready in {analysisDaysLeft} {dayPlural}
                    </div>
                </div>
            )}
            <div className="sp-content-desc">
                Dynamic Defense analyzes your network traffic to tailor a draft policy based on last 7 days usage,
                in minutes. Draft policy, if exists, will be deleted to allow the creation of the smart draft policy.
                <Link to={'https://kb-dynamicdefense.att.com/attdd/docs/smart-protection'} target="_blank" className="sp-content-learn-more">
                    Learn more
                </Link>
            </div>
        </div>
    );
};

